<template>
  <nav
    class="navbar navbar-expand navbar-light bg-white shadow-sm d-block p-1 d-print-none mb-1"
  >
    <ul class="navbar-nav">
      <template v-for="(l, i) in menu">
        <template v-if="l.type == 'M'">
          <li class="nav-item dropdown" :key="i">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              >{{ l.title }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link
                v-for="(l1, i1) in l.submenu"
                :key="i1"
                :to="l1.path"
                class="dropdown-item"
                >{{ l1.title }}</router-link
              >
            </div>
          </li>
        </template>
        <template v-else>
          <li class="nav-item" :key="i">
            <template v-if="l.type == 'I'">
              <router-link :to="l.path" class="nav-link">{{ l.title }}</router-link>
            </template>
            <template v-else>
              <a :href="l.path" class="nav-link">{{ l.title }}</a>
            </template>
          </li>
        </template>
      </template>

      <!-- <li class="nav-item" v-show="hasPermission('logistic')"> -->
      <!--   <a :href="logisticModule" class="nav-link"> -->
      <!--     Logistica -->
      <!--   </a> -->
      <!-- </li> -->
    </ul>
  </nav>
</template>
<script>
import { mapState } from "vuex";

export default {
  components: {
    //
  },
  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    ...mapState({
      all: (s) => s.config.user.can_load_all_menus,
      menu: (s) => s.user.menu // dental menu list
    }),
    logisticModule() {
      return this.$store.state.config.logistic.client.url;
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    hasPermission(permissions) {
      return this.$store.state.permissions.includes(permissions);
    }
  }
};
</script>

<style scoped></style>
